import { IUploadProcessData } from "models/processData/IUploadProcessData";

export const LOAD_PROCESS_DATA_DETAILS = "LOAD_PROCESS_DATA_DETAILS";

export interface LoadProcessDataDetails {
  type: typeof LOAD_PROCESS_DATA_DETAILS;
  payload: IUploadProcessData[];
}
export type ProcessDataActionTypes = LoadProcessDataDetails;
